module.exports = __webpack_public_path__ + "img/image18.e92479db.png";